import { NameValueModel } from "@app/models/basic-structures";

export class VotingItemDetailsDTO{
type:string;
classification: string;
classificationCode:string;
customFields: NameValueModel[];
}